module.exports = __webpack_public_path__ + "static/media/d3ru.f7a00fae.pdf";